import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ComponentsModule } from '@nx-customer-apps/components';

@Component({
    selector: 'rbr-default-values',
    templateUrl: './default-values.component.html',
    styleUrls: ['./default-values.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslatePipe, ComponentsModule]
})
export class DefaultValuesComponent {
    headerText = input<string>('RBR.DEFAULT_VALUES.TITLE');
}
